const FLAGGED_COLORS = ['red', 'orange'];
export const isConditionMetricFlagged = ({ evaluation_color, evaluation_text, evaluation_texts, }) => {
    if (!evaluation_color || !FLAGGED_COLORS.includes(evaluation_color)) {
        return false;
    }
    if (!evaluation_texts?.trim())
        return true;
    return evaluation_texts
        .split(',')
        .some(text => text.trim() === evaluation_text);
};
//# sourceMappingURL=isConditionMetricFlagged.js.map